import { type ReactNode } from 'react';

import { Search } from '@livechat/design-system-icons';

import { Filter } from 'constants/filters/filter';

import { type FilterConfig } from '../interfaces';

export const keywordFilterPlaceholder: string = 'E.g. "missing order" issues';

const keywordFilterDescription: ReactNode =
  'Count the chats where the keywords are present. You can look for specific words, phrases (using quotation marks), tags or agent names.';

export const keywordFilterConfig: FilterConfig = {
  title: 'Keyword',
  icon: Search,
  multiple: false,
  withCompare: false,
  description: keywordFilterDescription,
  infoTooltip: {
    content: keywordFilterDescription,
  },
  getFilterLabelValues: (filterValues, _items, _filterCompareValues) => {
    const label = filterValues && typeof filterValues === 'string' ? filterValues.trim() : '';
    if (!label) return [];
    return [
      {
        key: Filter.Keyword,
        label,
      },
    ];
  },
};
